import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df1d1ea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service" }
const _hoisted_2 = {
  class: "subaggregate",
  ref: "setRef"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString($props.headline), 1),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.unwindList.list, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["setRefDemo", {brandActie:($props.radioCheck===false?$setup.check_goods_exit(index):($setup.serviceActive === index))}]),
          key: item,
          onClick: ($event: any) => ($setup.categoryClick(item,index,$props.headline))
        }, [
          _createTextVNode(_toDisplayString(item.type) + " ", 1),
          (
            $props.radioCheck === false
              ? $setup.check_goods_exit(index)
              : $setup.serviceActive === index)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4))
            : _createCommentVNode("", true)
        ], 10, _hoisted_3))
      }), 128))
    ], 512)
  ]))
}